import React from 'react';
import { X } from 'lucide-react';

export default function Modal({ open, onClose, title, children, size = '', footer }) {
  if (!open) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={'modal ' + (size === 'lg' ? 'modal-lg' : size === 'xl' ? 'modal-xl' : '')} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="btn-close" onClick={onClose}><X size={20} /></button>
        </div>
        <div className="modal-body">{children}</div>
        {footer && <div className="modal-footer">{footer}</div>}
      </div>
    </div>
  );
}
